import { assertExecutionResult, parseResponse } from "gqty";

export async function responseHandler(response: Response) {
  const result: unknown = await parseResponse(response);
  assertExecutionResult(result);
  // GQty caches successful fields before reporting GraphQL errors. Throwing here
  // would discard that partial data and fail every selection in the request.
  return result;
}
